namespace TabAurous.Administration {
    export interface CampaignTemplatesForm {
        TemplateTypeId: Serenity.LookupEditor;
        ProviderTypeId: Serenity.LookupEditor;
        Code: Serenity.StringEditor;
        Title: Serenity.StringEditor;
        Message: Serenity.TextAreaEditor;
        Image: Serenity.ImageUploadEditor;
        Html: _Ext.HtmlTemplateEditor;
        Footer: Serenity.StringEditor;
        Url: Serenity.StringEditor;
    }

    export class CampaignTemplatesForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.CampaignTemplates';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CampaignTemplatesForm.init)  {
                CampaignTemplatesForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.ImageUploadEditor;
                var w4 = _Ext.HtmlTemplateEditor;

                Q.initFormType(CampaignTemplatesForm, [
                    'TemplateTypeId', w0,
                    'ProviderTypeId', w0,
                    'Code', w1,
                    'Title', w1,
                    'Message', w2,
                    'Image', w3,
                    'Html', w4,
                    'Footer', w1,
                    'Url', w1
                ]);
            }
        }
    }
}
